export default "__VITE_ASSET__VD1rHuYa__"